
import VueImageLightboxCarouselItem from './VueImageLightboxCarouselItem.vue'
import AppCarousel from '@/components/ui/AppCarousel.vue'

export default {
  name: 'Modal',
  components: { VueImageLightboxCarouselItem, AppCarousel },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showThumbs: {
      type: Boolean,
      default: true
    },
    showCaption: {
      type: Boolean,
      default: true
    },
    images: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      activeSlideIndex: 0,
      mainCarousel: null,
      thumbsCarousel: null
    }
  },
  computed: {
    commonCarouselOptions () {
      return {
        centeredSlides: true,
        preloadImages: false,
        initialSlide: this.activeSlideIndex
      }
    },
    mainCarouselOptions () {
      return {
        ...this.commonCarouselOptions,
        spaceBetween: 30,
        navigation: {
          nextEl: '.vue-lightbox-right',
          prevEl: '.vue-lightbox-left'
        },
        controller: { control: this.thumbsCarousel }
      }
    },
    thumbsCarouselOptions () {
      return {
        ...this.commonCarouselOptions,
        spaceBetween: 10,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.vue-lightbox-thumbnail-right',
          prevEl: '.vue-lightbox-thumbnail-left'
        },
        controller: { control: this.mainCarousel }
      }
    }
  },
  watch: {
    show: {
      handler (v) {
        const toggleDocumentListener = v
          ? document.addEventListener
          : document.removeEventListener

        toggleDocumentListener('keydown', this.onEscapeKeyPress)
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    onEscapeKeyPress (event) {
      const escapeKeyCode = 27

      if (event.keyCode !== escapeKeyCode) {
        return
      }

      this.close()
    },
    showImage (index = 0) {
      this.activeSlideIndex = index
    },
    onMainCarouselInit (carousel) {
      this.mainCarousel = carousel
    },
    onThumbsCarouselInit (carousel) {
      this.thumbsCarousel = carousel
    },
    onSlideChange ({ activeIndex }) {
      this.activeSlideIndex = activeIndex
    }
  }
}
